import React from "react";
import "./AnghamiForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const AnghamiForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Anghami",
    "Get your artist profile live",
    "Reach Middle East listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on Anghami | Anghami Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Upload your music to Anghami with FT Tunes music distribution. Reach millions of listeners across the Middle East and North Africa and grow your global audience."
        />

        <meta
          name="keywords"
          content="Anghami music distribution, upload music to Anghami, Anghami for artists India, FT Tunes distribution, music distribution Middle East"
        />

        <meta name="robots" content="index, follow" />

        <meta property="og:title"
          content="Get Your Music on Anghami | FT Tunes"
        />

        <meta property="og:type" content="website" />

        <meta property="og:url"
          content="https://www.fttunes.com/get-your-music-on-anghami"
        />

      </Helmet>

      <div className="anghami-page">

        {/* HERO */}
        <section className="anghami-hero">
          <Container>

            <img
              src="/Images/anghami-logo.png"
              alt="Get Music on Anghami"
              className="anghami-logo"
            />

            <h1>Get Your Music on Anghami</h1>

            <p>
              Distribute your music on Anghami and connect with millions of
              listeners across the Middle East and North Africa. Anghami is one
              of the leading streaming platforms in the Arabic music market,
              helping independent artists grow internationally. Release your
              singles, albums, and EPs worldwide, build your fanbase, and earn
              streaming royalties while maintaining complete ownership of your
              music.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-anghami"></div>
        </section>

        {/* SHOWCASE */}
        <section className="anghami-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Expand Your Music Across The Middle East</h2>

                <p>
                  Reach new audiences in UAE, Saudi Arabia, Egypt and global
                  Arabic markets through Anghami's powerful streaming ecosystem.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-anghami.png"
                  alt="Anghami music distribution"
                  className="anghami-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="anghami-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="anghami-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Middle East Reach</h5>
                  <p>Access millions of listeners across MENA regions.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You retain full rights to your music.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Streaming Revenue</h5>
                  <p>Earn royalties from every play.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Growth</h5>
                  <p>Build global exposure and fan engagement.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="anghami-cta">
          <Container>

            <h2>Start Growing on Anghami Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default AnghamiForArtists;